/** @prettier */

import {memo} from 'react';
import {graphProps} from '../../../Type/TypeDef';
import FloorGraph from './FloorGraph';
import GroupGraph from './GroupGraph';
import ModbusIndoorGraph from './ModbusIndoorGraph';
import HyozanIndoorGraph from './HyozanIndoorGraph';
import SiteGraph from './SiteGraph';
import UnitGraph from './UnitGraph';

//-----------------------------
//	空調機グラフの選択
//-----------------------------

export const AirconGraph = memo((props: {graphProps: graphProps}) => {
  const SelectGraph = () => {
    switch (props.graphProps.graphTarget) {
      case 'site':
        return <SiteGraph graphProps={props.graphProps} />;
      case 'floors':
        return <FloorGraph graphProps={props.graphProps} />;
      case 'groups':
        return <GroupGraph graphProps={props.graphProps} />;
      case 'sl':
        return <UnitGraph graphProps={props.graphProps} />;
      case 'modbusIndoor':
        return <ModbusIndoorGraph graphProps={props.graphProps} />;
      case 'hyozanIndoor':
        return <HyozanIndoorGraph graphProps={props.graphProps} />;
      default:
        return <></>;
    }
  };
  return <SelectGraph />;
});
